import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { getCurrentUser } from '../utils/auth';

export default function SupplierOrders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);

    const currentUser = getCurrentUser();

    const supplierId = currentUser?.supplierId;

    useEffect(() => {
        if (!supplierId) return;

        const fetchOrders = async () => {
            try {
                setLoading(true);
                const res = await api.get(`/api/shipping/supplier/${supplierId}`);
                setOrders(res.data);
            } catch (err) {
                console.error('❌ Failed to fetch supplier orders', err);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [supplierId]);

    const updateStatus = async (orderId, status) => {
        try {
            const res = await api.put(`/api/shipping/${orderId}/status`, { status });

            // update UI instantly
            setOrders(prev =>
                prev.map(o => o._id === orderId ? res.data : o)
            );
        } catch (err) {
            console.error('❌ Failed to update status', err);
        }
    };

    if (!supplierId) {
        return <p className="text-red-500">No supplier selected.</p>;
    }

    return (
        <div className="max-w-6xl mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">Supplier Orders</h2>

            {loading ? (
                <p>Loading orders...</p>
            ) : orders.length === 0 ? (
                <p className="text-gray-500">No orders found.</p>
            ) : (
                <table className="w-full border">
                    <thead>
                        <tr className="bg-gray-200 text-sm">
                            <th className="p-2">Order ID</th>
                            <th className="p-2">User</th>
                            <th className="p-2">Group</th>
                            <th className="p-2">Portion</th>
                            <th className="p-2">Amount</th>
                            <th className="p-2">Type</th>
                            <th className="p-2">Status</th>
                            <th className="p-2">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {orders.map(o => (
                            <tr key={o._id} className="text-center border-t">
                                <td className="p-2 text-xs">{o._id}</td>
                                <td className="p-2">{o.userId?.username || 'N/A'}</td>
                                <td className="p-2">{o.groupId?.name || 'N/A'}</td>
                                <td className="p-2">{o.portion}</td>
                                <td className="p-2">${o.amountPaid}</td>
                                <td className="p-2 capitalize">{o.fulfillmentType}</td>

                                {/* ✅ FIXED FIELD */}
                                <td className="p-2">
                                    <span className="px-2 py-1 rounded bg-blue-100 text-blue-700 text-xs">
                                        {o.status?.replaceAll('_', ' ')}
                                    </span>
                                </td>

                                <td className="p-2 space-x-1">
                                    <button
                                        onClick={() => updateStatus(o._id, 'processing')}
                                        className="bg-yellow-400 px-2 py-1 rounded text-xs"
                                    >
                                        Processing
                                    </button>

                                    <button
                                        onClick={() => updateStatus(o._id, 'packed')}
                                        className="bg-orange-400 px-2 py-1 rounded text-xs"
                                    >
                                        Packed
                                    </button>

                                    {o.fulfillmentType === 'delivery' && (
                                        <>
                                            <button
                                                onClick={() => updateStatus(o._id, 'shipped')}
                                                className="bg-purple-400 px-2 py-1 rounded text-xs"
                                            >
                                                Shipped
                                            </button>

                                            <button
                                                onClick={() => updateStatus(o._id, 'out_for_delivery')}
                                                className="bg-indigo-400 px-2 py-1 rounded text-xs"
                                            >
                                                Out
                                            </button>

                                            <button
                                                onClick={() => updateStatus(o._id, 'delivered')}
                                                className="bg-green-500 text-white px-2 py-1 rounded text-xs"
                                            >
                                                Delivered
                                            </button>
                                        </>
                                    )}

                                    {o.fulfillmentType === 'pickup' && (
                                        <button
                                            onClick={() => updateStatus(o._id, 'ready_for_pickup')}
                                            className="bg-green-500 text-white px-2 py-1 rounded text-xs"
                                        >
                                            Ready
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
